const env = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_COUPON_URL:
    process.env.REACT_APP_COUPON_LAMBDA_URL || "http://localhost:3030",
  RECENT_HIGHLIGHTED: process.env.REACT_APP_RECENT_HIGHLIGHTED || 10,
  REFRESH_TIME: process.env.REACT_APP_REFRESH_TIME || 10000,
  S3_BUCKET_URL: process.env.REACT_APP_S3_BUCKET_URL || "",
};

export { env };
